import React, { FC, useState } from 'react'
import { Download, KeyboardDoubleArrowDown } from '@mui/icons-material'
import { Button, Dialog } from '../../ui'
import { ReactComponent as Windows } from '../../../assets/icons/os_windows.svg'
import { ReactComponent as Apple } from '../../../assets/icons/os_apple.svg'
import cn from '../../../lib/utils/cn'

interface DownloadAuraClientModalProps {
	isOpen: boolean
	onClose: () => void
}

const DownloadAuraClientModal: FC<DownloadAuraClientModalProps> = ({
	isOpen,
	onClose,
}) => {
	const [selected, setSelected] = useState<null | 'macos' | 'windows'>(null)
	const isWindows = selected === 'windows'
	const isMacOS = selected === 'macos'

	const handleClose = () => {
		setSelected(null)
		onClose()
	}

	const handleDownloadClient = async () => {
		if (!selected) {
			return
		}
		const url = `${process.env.REACT_APP_BACKEND_API}/desktop/${selected}/download`
		window.open(url)
		handleClose()
	}

	return (
		<Dialog
			isOpen={isOpen}
			onClose={handleClose}
			className="max-w-[430px] box-border"
		>
			<div className="flex flex-col gap-5">
				<div className="flex items-center justify-between gap-5 w-full">
					<div
						className={cn(
							'flex flex-col justify-between items-center border  rounded-lg min-w-[184px] w-[184px] h-[184px] overflow-hidden cursor-pointer',
							isWindows
								? 'border-accent bg-accent-light'
								: 'border-stroke-light  dark:border-stroke-light-dark  bg-white dark:bg-background-light-hover-dark',
						)}
						onClick={() =>
							setSelected((prev) => (prev === 'windows' ? null : 'windows'))
						}
					>
						<div className="m-auto">
							<Windows
								className={cn(
									isWindows
										? 'fill-accent'
										: 'fill-text-main dark:fill-text-main-dark',
								)}
							/>
						</div>
						<p
							className={cn(
								'w-full flex items-center justify-center text-center font-medium text-sm border-t h-12',
								isWindows
									? 'text-white bg-accent  border-accent'
									: 'text-text-main dark:text-text-main-dark bg-background-light dark:bg-background-light-dark border-stroke-light dark:border-stroke-light-dark',
							)}
						>
							Windows
						</p>
					</div>

					<div
						className={cn(
							'flex flex-col justify-between items-center border  rounded-lg min-w-[184px] w-[184px] h-[184px] overflow-hidden cursor-pointer',
							isMacOS
								? 'border-accent bg-accent-light'
								: 'border-stroke-light  dark:border-stroke-light-dark  bg-white dark:bg-background-light-hover-dark',
						)}
						onClick={() =>
							setSelected((prev) => (prev === 'macos' ? null : 'macos'))
						}
					>
						<div className="m-auto">
							<Apple
								className={cn(
									isMacOS
										? 'fill-accent'
										: 'fill-text-main dark:fill-text-main-dark',
								)}
							/>
						</div>
						<p
							className={cn(
								'w-full py-4 text-center font-medium text-sm border-t ',
								isMacOS
									? 'text-white bg-accent  border-accent'
									: 'text-text-main dark:text-text-main-dark bg-background-light dark:bg-background-light-dark border-stroke-light dark:border-stroke-light-dark',
							)}
						>
							Mac OS
						</p>
					</div>
				</div>

				<div className="flex items-center justify-between gap-10">
					<div className="h-1 mb-1 w-full border-b border-stroke-light dark:border-stroke-light-dark " />
					<KeyboardDoubleArrowDown
						className={cn(selected ? 'fill-accent' : 'fill-stroke-light')}
					/>
					<div className="h-1 mb-1 w-full border-b border-stroke-light dark:border-stroke-light-dark " />
				</div>

				<Button
					label="Download"
					leftIcon={<Download />}
					onClick={handleDownloadClient}
					disabled={!selected}
					className="w-full flex items-center justify-center"
				/>
			</div>
		</Dialog>
	)
}

export default DownloadAuraClientModal
